import { Middleware } from '@reduxjs/toolkit';

import { stopPollingAlertsAction } from '@sternum/web/features/alerts/slice';
import { appStorage } from '@sternum/web/services/appStorage';

import { anomaliesSlice, AnomaliesState, toggleAreAnomalyNotesVisibleAction } from './anomalies.slice';

export const anomaliesMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  const anomaliesState = api.getState()?.[anomaliesSlice.name];
  const stopPolling = () => api.dispatch(stopPollingAlertsAction());

  if (anomaliesState) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // NOTE: Middleware is executed AFTER given action
    anomaliesMiddlewares[action?.type]?.(anomaliesState, { stopPolling });
  }

  return result;
};

const anomaliesMiddlewares = {
  [toggleAreAnomalyNotesVisibleAction.type]: (state: AnomaliesState) => {
    appStorage.setAreAnomalyNotesVisible(state.areAnomalyNotesVisible);
  },
};
